import React from 'react';
import { Route, Switch } from 'react-router';

import VehicleCreate from './VehicleCreate';
import VehicleDetail from './VehicleDetail';
import VehicleList from './VehicleList/Vehicles';

export default function Vehicles() {
  return (
    <Switch>
      <Route path="/vehicles/create" component={VehicleCreate} />
      <Route path="/vehicles/:id" component={VehicleDetail} />
      <Route path="/vehicles" component={VehicleList} />
    </Switch>
  );
}
